import React from 'react';
import LocalizedStrings from "react-localization";
import {common_strings} from "../../translations/common_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import Button from "reactstrap/es/Button";

let commonStrings = new LocalizedStrings(common_strings);

const CPTableRow = (props) => {

    function localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
    }

    localize();

    return (
        <tr style={{backgroundColor: "white"}}>
            <Button onClick={e => props.onSelected(e, props.item)}
                    color="secondary" size="lg" className="align-items-left mt-2 text-default font-weight-900"
                    style={{width: "100%"}}>
                {props.item.title}
            </Button>
        </tr>
    )
};

export default CPTableRow;